import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {IVendorOffer} from "../../offer/types/VendorOffer";

export function isActiveVendorOffer(offer: IVendorOffer) {
    return offer.configuration.display_type === OfferDisplayType.FOR_SALE && !offer.configuration.limited_presentation && offer.is_active;
}
import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {IVendorOffer} from "../../offer/types/VendorOffer";

export function isActiveVendorOffer(offer: IVendorOffer) {
    return offer.configuration.display_type === OfferDisplayType.FOR_SALE && !offer.configuration.limited_presentation && offer.is_active;
}
